
interface AuthFormFooterProps {
  isLogin: boolean;
  loading: boolean;
  onToggle: () => void;
  onResetClick: () => void;
}

const AuthFormFooter = ({ isLogin, loading, onToggle, onResetClick }: AuthFormFooterProps) => {
  return (
    <div className="mt-4">
      <button
        type="submit"
        className="w-full bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700 flex justify-center"
        disabled={loading}
      >
        {loading ? "Laadin..." : isLogin ? "Logi sisse" : "Loo konto"}
      </button>
      
      <div className="mt-4 text-center text-sm">
        {isLogin ? (
          <>
            <p>
              Pole veel kontot?{" "}
              <button
                type="button"
                onClick={onToggle}
                className="text-blue-600 hover:underline font-medium"
              >
                Registreeru
              </button>
            </p>
            <button
              type="button"
              onClick={onResetClick}
              className="text-blue-600 hover:underline font-medium mt-2"
            >
              Unustasid parooli?
            </button>
          </>
        ) : (
          <p>
            Sul on juba konto?{" "}
            <button
              type="button"
              onClick={onToggle}
              className="text-blue-600 hover:underline font-medium"
            >
              Logi sisse
            </button>
          </p>
        )}
      </div>
    </div>
  );
};

export default AuthFormFooter;
